import { CHANGE_LOGIN_VALUE } from './actionTypes';

export function changeLoginValue(value) {
    
    console.log("log inside action");
    console.log(value);
    return {
        type: CHANGE_LOGIN_VALUE,
        isLogged: value
    }
}